// extracted by mini-css-extract-plugin
var _1 = "xteGA__ticks";
var _2 = "xteGA__ticks__tick";
export { _1 as "ticks", _2 as "ticks__tick" }
